import React, { Component } from 'react'
import Helmet from 'react-helmet'
import uuidv4 from 'uuid/v4'
import { Modal as AntdModal } from 'antd-mobile'
import ScrollObserver from '~/components/ScrollObserver'
import Swiper from '~/components/Swipe'
import { getWealTypes, getIndexImage } from '~/services'
import {
  initializeNativeShare,
  universalOpenUrl,
  getImageHeight,
  getPlatform,
  sessionInstall,
} from '~/utils'
import Activity from './activity'
import styles from './index.css'

export default class Home extends Component {
  state = {
    wealTypes: {},
    hotActivityList: [],
    isFetchingHotActivityList: false,
    moreTypes: [1],
    showInformation: localStorage.getItem('home:information') !== 'true',
    carousel: [],
    carouselHeight: getImageHeight(156),
    brandsList: [],
  }

  componentDidMount() {
    sessionInstall()
    getWealTypes().then(({ data }) => {
      this.setState({ wealTypes: data })
    })
    this.handleHotActivity()
    this.handleIndexBanner()
    this.handleBrand()

    initializeNativeShare({
      title: '找热门活动，获奖品优惠，来知乎活动广场！',
      description:
        '有奖问答、读书会、知乎联名卡等海量活动都在这里，参与就有机会赢福利！',
    })
  }

  // 获取 banner 图片
  handleIndexBanner = () => {
    getIndexImage({
      wealType: 4,
      pageSize: 5,
      pageNum: 1,
    }).then(({ data }) => {
      this.setState({
        carousel: data.pageData,
      })
    })
  }

  // 获取品牌合作图片
  handleBrand = () => {
    getIndexImage({
      wealType: 3,
    }).then(({ data }) => {
      this.setState({
        brandsList: data.pageData,
      })
    })
  }

  handleHotActivity = isReload => {
    const {
      isFetchingHotActivityList,
      moreTypes,
      hotActivityList: oldHotActivityList,
    } = this.state

    if (isFetchingHotActivityList) {
      return
    }

    this.setState({ isFetchingHotActivityList: true })

    const pageSize = 20
    const remainder = oldHotActivityList.length % pageSize
    const pageNum = remainder
      ? Math.ceil(oldHotActivityList.length / pageSize)
      : oldHotActivityList.length / pageSize + 1

    getIndexImage({
      pageNum: isReload ? 1 : pageNum,
      pageSize,
      wealType: 2,
      types: moreTypes.join(','),
    })
      .then(({ data }) => {
        this.setState({
          isFetchingHotActivityList: false,
          hotActivityList: isReload
            ? data.pageData
            : oldHotActivityList
                .splice(0, oldHotActivityList.length - remainder)
                .concat(data.pageData),
        })
      })
      .catch(() => {
        this.setState({ isFetchingHotActivityList: false })
      })
  }

  handleItemClick = url => () => {
    universalOpenUrl(url)
  }

  handleTypeSelect = id => () => {
    const { moreTypes } = this.state
    let finalMoreTypes = []

    if (id === 1) {
      finalMoreTypes = [1]
    } else if (moreTypes.includes(id)) {
      finalMoreTypes = moreTypes.filter(i => ![1, id].includes(i))
    } else {
      finalMoreTypes = moreTypes.filter(i => i !== 1).concat([id])
    }

    if (!finalMoreTypes.length) {
      finalMoreTypes = [1]
    }

    this.setState({ moreTypes: finalMoreTypes })
  }

  renderMoreItem = (item, index) => (
    <Activity
      key={`hotActivityItem_${uuidv4()}`}
      index={index}
      item={item}
      wealTypes={this.state.wealTypes}
    />
  )

  renderInformation = () => {
    const { showInformation } = this.state
    const handleClose = () => {
      this.setState(
        {
          showInformation: false,
        },
        () => {
          localStorage.setItem('home:information', 'true')
        }
      )
    }
    return (
      <AntdModal
        className={styles.homeInformationModal}
        transparent
        maskClosable
        visible={showInformation}
        onClose={handleClose}
        footer={[{ text: '我知道了', onPress: handleClose }]}
      >
        <div className={styles.homeInformation}>
          活动广场中有部分服务由第三方提供，相应页面将跳转到第三方平台。您已明确知悉，这些服务的使用规则及个人信息保护制度以第三方公示的文件为准。
        </div>
      </AntdModal>
    )
  }
  renderSingleImage = (item, index) => {
    const { carouselHeight } = this.state
    return (
      <div
        onClick={() => this.bannerItemClick(item, index)}
        className={styles.bannerLink}
        style={{ height: carouselHeight }}
        key={item.targetUrl}
      >
        <img alt="" src={item.imageUrl} className={styles.bannerImg} />
        <div className={styles.bannerTitleWrap}>
          <span className={styles.bannerTitle}>{item.wealName}</span>
        </div>
      </div>
    )
  }

  // 模块名字
  renderTitle = title => {
    return (
      <div className={styles.brandCooperationHeader}>
        <span
          style={{ top: getPlatform() === 'android' ? '-.01rem' : '-.006rem' }}
        />
        <span>{title}</span>
      </div>
    )
  }

  render() {
    const { wealTypes, hotActivityList = [], brandsList } = this.state

    if (!wealTypes) {
      return null
    }

    return (
      <ScrollObserver onScrollToBottom={this.handleHotActivity}>
        <Helmet title="活动广场" />
        <div className={styles.home}>
          {!!this.state.carousel &&
            this.state.carousel.length > 0 && (
              <Swiper
                brandsList={this.state.carousel}
                swiperWH={{ width: '100%' }}
                md={0}
              />
            )}
          <div>
            {!!brandsList &&
              brandsList.length > 0 && (
                <div className={styles.brandCooperationHeaderWrap}>
                  {this.renderTitle('品牌合作')}
                </div>
              )}
            {!!brandsList &&
              brandsList.length > 0 && (
                <Swiper
                  brandsList={brandsList}
                  swiperWH={{ height: '1.2rem', width: '3.43rem' }}
                  style={{ borderRadius: '.08rem' }}
                  md={1}
                />
              )}
          </div>
          <div className={styles.hotActivity}>
            {this.renderTitle('热门活动')}
            <div
              className={styles.hotActivityList}
              onLoad={this.handleHotActivity}
            >
              {hotActivityList.map(this.renderMoreItem)}
            </div>
          </div>
        </div>
        {this.renderInformation()}
      </ScrollObserver>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js